import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import '../styles/componentsStyles/LeaderBoard.css';
import BoardList from './BoardList';
import TopLeaders from './TopLeaders';

function LeaderBoard({
  isActive,
  isChallengeUnavailable,
  handleToggle,
  isOn,
  leaders,
  users,
  challengeType,
  userPlace,
  buttonText,
  handleButtonClick,
}) {
  const { t } = useTranslation();
  const emptyLeaders = Array.from(Array(3).keys());
  const [dataToMap, setDataToMap] = useState(emptyLeaders);

  useEffect(() => {
    if (leaders.length > 0) {
      setDataToMap(leaders);
    } else {
      setDataToMap(emptyLeaders);
    }
  }, [leaders]);

  return (
    <div
      className={`chart-container leaderboard tile half ${
        isActive || isChallengeUnavailable ? 'active' : 'inactive'
      }`}
      role="group"
      aria-label={`${t('CH028')}`}
    >
      <div className="title-container leader-board">
        <h3 className="title">{t('CH028')}</h3>
        {isActive && (
          <div className="switcher-container">
            {' '}
            <p className="subtitle">{t('CH029')}</p>
            <div className="">
              <label
                className={`whc-switch ${isOn ? 'on' : 'off'}`}
                aria-label={`${t('CH028')} ${t('CH029')} ${isOn ? t('leaderboard.switch.on') : t('leaderboard.switch.off')}`}
              >
                <input
                  type="checkbox"
                  checked={isOn}
                  onChange={handleToggle}
                  className="whc-switch-input visuallyHidden"
                />
                <div className="whc-slider-button" />
              </label>
            </div>
          </div>
        )}
      </div>
      <div className="leaders-content-wrapper fs-mask">
        <TopLeaders
          dataToMap={dataToMap}
          challengeType={challengeType}
          leadersNumber={leaders.length}
          buttonText={buttonText}
          isActive={isActive}
          handleButtonClick={handleButtonClick}
        />
        {users.length === 0 ? (
          <div className="leaders-noleaders">
            {isChallengeUnavailable ? t('CH040') : t('CH030')}
          </div>
        ) : (
          <BoardList
            users={users}
            challengeType={challengeType}
            userPlace={userPlace}
            leaders={leaders}
          />
        )}
      </div>
    </div>
  );
}

export default LeaderBoard;
